import { Routes } from '@angular/router';
import { LayoutComponent } from '../layout/layout.component';
import {AuthGuard} from '../shared/guards/auth.guard';
import {MessagerieComponent} from "../messagerie/messagerie.component";

export const routes: Routes = [

    {
        path: '',
        component: LayoutComponent, canActivateChild: [AuthGuard],
        children: [
            { path: '', redirectTo: '/home', pathMatch: 'full'},
            { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
            { path: 'messagerie', component: MessagerieComponent },
            { path: 'backoffice', loadChildren: () => import('./backoffice/backoffice.module').then(m => m.BackofficeModule) }
        ]
    },

    {path: 'page', loadChildren:  () => import('./pages/pages.module').then(m => m.PagesModule) },

    // Not found
    { path: '**', redirectTo: '/page/404' }

];



export const routes1 = [

  {
    path: '',
    component: LayoutComponent, canActivateChild: [AuthGuard],
    children: [
      {path: '', redirectTo: '/home', pathMatch: 'full'},
      {path: 'home', loadChildren: './home/home.module#HomeModule'}
    ]
  },
  {path: 'page', loadChildren: './pages/pages.module#PagesModule'},

  // Not found
  {path: '**', redirectTo: '/page/404'}

];
